import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  constructor(private _user: UserService,
    public router: Router
    ) { }

  ngOnInit(): void {
  }

  goBack(){
    if(this._user.getUser()){
      if(this._user.getUser().actor == "microempresario"){
        this.router.navigate(['/microempresario/home']);
      }else if(this._user.getUser().actor == "intermediario"){
        this.router.navigate(['/intermediario/home']);
      }
    }else{
      this.router.navigate(['/home']);
    }
  }
}
